@if (currentMap$ | async; as currentMap) {
  @if (coursesToSelect.length > 1) {
    <lsl-select [noRadius]="true" [formControl]="courseControl" [entities]="coursesToSelect"></lsl-select>
  }
  @if (coursesToSelect.length <= 1) {
    <span>{{ currentMap.display_name }}</span>
  }
}
